import React from 'react';
import PropTypes from 'prop-types';

import ContentBox from 'components/checkout/caap/ContentBox';
import { Row } from 'components/checkout/caap/Layout';
import {
  item as styleItem,
  itemBox as styleItemBox,
  itemContainer as styleItemContainer,
  last as styleLast
} from 'styles/components/checkout/caap/contentBox.scss';
import css from 'styles/components/checkout/caap/spc/condensedReviewItems.scss';

const CondensedRetailItems = (params, { testId }) => {
  const {
    deliveryGroup,
    productsByLineItem,
    shipOptionsSection,
    hasShipOptions
  } = params;

  const { lineItemIds } = deliveryGroup;

  return (
    <>
      <ContentBox isFirst={true} isNonRadio={true}>
        { hasShipOptions ? shipOptionsSection : null }
      </ContentBox>

      {
        lineItemIds.slice().map((unmappedLineItemId, index) => {
          const mappedItem = productsByLineItem[unmappedLineItemId] || { image: { url: '', alt: '' } };
          const { image: { url: imageUrl, alt: imageAlt }, productName } = mappedItem;
          const isLast = index === lineItemIds.length - 1;

          return (
            <div className={styleItemContainer} key={`review-item-cb-${index}`} data-test-id={hasShipOptions ? testId('retailShippableItemContainer') : testId('retailNonShippableItemContainer')}>
              <div className={`${styleItemBox} ${isLast ? styleLast : ''}`}>
                <Row>
                  <div className={styleItem}>
                    <div className={css.reviewItem}>
                      <span className={css.reviewImageContainer}>
                        <div>
                          <img width="70" src={imageUrl} alt={imageAlt} />
                        </div>
                      </span>
                      <div>
                        {productName}
                      </div>
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          );
        })
      }
    </>
  );
};

CondensedRetailItems.contextTypes = {
  testId: PropTypes.func
};

export default CondensedRetailItems;
